/**
 * URL construction for sub-path hosting.
 *
 * The app is served from `https://apps.deodap.info/ship-order`, a sub-path of a
 * domain that also hosts the main site. Every URL this client builds must
 * therefore be relative to that prefix — an absolute `/api/...` would leave the
 * app entirely and hit the MAIN DOMAIN's API instead, which is both a broken
 * request and a request sent somewhere it does not belong.
 *
 * `import.meta.env.BASE_URL` is Vite's build-time `base`, always with a
 * trailing slash:
 *
 *   development           BASE_URL = "/"             -> /api/l48/meta
 *   built with base=/ship-order/  BASE_URL = "/ship-order/" -> /ship-order/api/l48/meta
 *
 * Deriving from it means there is one place to change the mount point (the
 * build's `base`) and no hardcoded prefix anywhere in the client.
 */

/** Vite guarantees a trailing slash; strip it so joins are unambiguous. */
const BASE = import.meta.env.BASE_URL.replace(/\/+$/, '');

/** Join a root-relative path onto the app's mount prefix. */
export function appUrl(pathname: string): string {
  const suffix = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${BASE}${suffix}`;
}

/** Prefixed API roots. */
export const API_DASHBOARD = appUrl('/api/l48');
export const API_AUTH = appUrl('/api/auth');
